// <zzy-spinner></zzy-spinner>
class ZzySpinner extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `
      <span style="display:inline-flex;align-items:center;gap:8px;color:var(--zzy-text-mute);font:500 13px/1 var(--zzy-font)">
        <span style="
          width:14px;height:14px;border-radius:50%;
          border:2px solid var(--zzy-border);border-top-color:var(--zzy-accent);
          animation:zzy-spin .8s linear infinite;
        "></span>
        ${this.textContent || 'Carregando…'}
      </span>
      <style>@keyframes zzy-spin{to{transform:rotate(360deg)}}</style>
    `;
  }
}
customElements.define('zzy-spinner', ZzySpinner);
